/* eslint-disable */

import React from 'react';
import { range } from 'lodash';

import Form from 'src/components/Form/Form';
import UniverseAware from 'src/utils/UniverseAware';

@UniverseAware
class FindAccountForm extends Form {
    static fieldsValidation = {
        id: ['numeric'],
        email: [[ 'minLength' , 3]]
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { universePrefix } = this.props;

        return (
            <div className='row error-message-below'>
                <div className='col-6'>
                    <div className='row'>
                        <div className='form-prefix-group'>
                            {universePrefix ? <span className='form-prefix-group__label'>{universePrefix}</span> : undefined}
                            {
                                this.getField(
                                    <input type='text'
                                        label='Account ID'
                                        {...this.getFieldParameters('id')}
                                    />
                                )
                            }
                        </div>
                    </div>

                    {
                        this.getField(
                            <input type='text'
                                label='First name'
                                {...this.getFieldParameters('firstName')}
                            />
                        )
                    }

                    {
                        this.getField(
                            <input type='text'
                                label='Surname'
                                {...this.getFieldParameters('surname')}
                            />
                        )
                    }

                    {
                        this.getField(
                            <input type='text'
                                label='Mobile phone'
                                {...this.getFieldParameters('mobilePhone')}
                            />
                        )
                    }
                </div>

                <div className='col-6'>
                    {
                        this.getField(
                            <input type='text'
                                label='Telebetting ID'
                                {...this.getFieldParameters('telebettingId')}
                            />
                        )
                    }

                    {
                        this.getField(
                            <input type='text'
                                label='E-mail'
                                {...this.getFieldParameters('email')}
                            />
                        )
                    }

                    {
                        this.getField(
                            <input type='text'
                                label='Postcode'
                                {...this.getFieldParameters('postCode')}
                            />
                        )
                    }
                </div>

                <div className='col-12'>
                    <div className='buttons'>
                        <button className='btn btn-primary' type='submit' data-test='find-customer-button'>
                            Find customer
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FindAccountForm;
